/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Link } from '../../models/link';

export interface LinksControllerFindById$Params {
  id: string;
}

export function linksControllerFindById(http: HttpClient, rootUrl: string, params: LinksControllerFindById$Params, context?: HttpContext): Observable<StrictHttpResponse<Link>> {
  const rb = new RequestBuilder(rootUrl, linksControllerFindById.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Link>;
    })
  );
}

linksControllerFindById.PATH = '/links/{id}';
